import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { WeekDay } from '@mews/enums';
import { DateTimeService, DateTimeUtc, DateTimeUtcService } from '@mews/framework';
import { getHash } from '../../utils/getHash';

interface GetServiceAvailabilityHashOptions {
    serviceId: string;
    categoryId: string;
}

export const getServiceAvailabilityHash = ({ categoryId, serviceId }: GetServiceAvailabilityHashOptions) =>
    getHash({
        categoryId,
        serviceId,
    });

interface GetServiceAvailabilityRequestIdOptions {
    endUtc: DateTimeUtc;
    startUtc: DateTimeUtc;
    serviceId: string;
}

export const getServiceAvailabilityRequestId = ({
    startUtc,
    endUtc,
    serviceId,
}: GetServiceAvailabilityRequestIdOptions) =>
    getHash({
        startUtc: DateTimeUtcService.toISOString(startUtc),
        endUtc: DateTimeUtcService.toISOString(endUtc),
        serviceId,
    });

export interface MakeUtcDatesParams {
    startUtc: DateTimeUtc;
    endUtc: DateTimeUtc;
    includeEndUtc: boolean;
    timezone: string;
}
/**
 * @returns array of dateTimeUtc ISO strings without milliseconds
 */
export const makeUtcDates = ({ startUtc, endUtc, includeEndUtc, timezone }: MakeUtcDatesParams): string[] => {
    const startDateTime = DateTimeService.fromUtc(startUtc, timezone);
    const endDateTime = DateTimeService.fromUtc(endUtc, timezone);
    const createDate = (i: number): string =>
        pipe(
            DateTimeService.addDays(startDateTime, i),
            (date) => DateTimeService.toUtc(date),
            (dateTimeUtc) => DateTimeUtcService.toISOString(dateTimeUtc, { suppressMilliseconds: true })
        );

    const range = DateTimeService.diffDays(endDateTime, startDateTime) + (includeEndUtc ? 1 : 0);

    return array.makeBy(range, createDate);
};

export const weekdayIndexes = [
    WeekDay.Sunday,
    WeekDay.Monday,
    WeekDay.Tuesday,
    WeekDay.Wednesday,
    WeekDay.Thursday,
    WeekDay.Friday,
    WeekDay.Saturday,
];
